import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=f378f97c&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=f378f97c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f378f97c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f378f97c')) {
      api.createRecord('f378f97c', component.options)
    } else {
      api.reload('f378f97c', component.options)
    }
    module.hot.accept("./NotFoundPage.vue?vue&type=template&id=f378f97c&scoped=true", function () {
      api.rerender('f378f97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/NotFoundPage.vue"
export default component.exports